{
  "chart.area": "Area",
  "chart.bar": "Bar",
  "chart.pie": "Pie",
  "chart.radar": "Radar",
  "chartChooser.chooseChart": "Choose chart",
  "chartChooser.missingData": "Missing data for chart.",
  "chartChooser.noSelect": "No chart selected.",
  "chartChooser.unavailable": "Chart type unavailable.",
  "numberOf": "Number of"
}
